import { Box } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';

export const Placeholder = ({ placeholder }: { placeholder?: string }) => {
  return (
    <Box sx={{ position: 'absolute', top: '8px', left: '8px' }}>
      <Typography variant="body" color={colors.grey[700]}>
        {placeholder}
      </Typography>
    </Box>
  );
};
